import { Outlet } from 'react-router-dom';

import { Toaster } from '@/components/shadcn/ui/sonner';
import { Footer } from '@/layout/Footer/Footer';
import { Header } from '@/layout/Header/Header';

export const Layout = () => {
  return (
    <>
      <Header />
      <main className="mb-4 flex flex-col items-center gap-6">
        <Outlet />
      </main>
      <Toaster />
      <Footer />
    </>
  );
};
